export const calcularPorcentaje = (cantidad: number, total: number, decimales: number): string => {
  if (total === 0) {
    return '0'; // Para evitar una división por cero
  }

  const porcentaje = (cantidad / total) * 100;
  return porcentaje.toFixed(decimales);
}